type QueryStringObjType = {
  web_form_key: string;
  region?: 'us' | 'ca' | 'eu' | 'au';
};

export const parseQueryString = () => {
  const queryString = window.location.search;
  const queryObj: Record<string, string> = {};
  const queryReg = /([^?&=]+)=([^&=]+)/g;

  queryString.replace(queryReg, (...arg) => (queryObj[arg[1]] = arg[2]));
  return queryObj as QueryStringObjType;
};
